import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, IconContainer, LinkButton, PseudoButton } from './styles';
import { PromoIcon } from '../PromoIcon/PromoIcon';
import { PromoSpinnerCircle } from '../PromoSpinner/PromoSpinnerCircle';

export const PromoButton = React.forwardRef(({ variant = 'primary', ...props }, ref) => {
    if (props.type === 'link') {
        return (
            <LinkButton ref={ref} variant={variant} {...props}>
                {props.caption}
                {props.iconName && (
                    <IconContainer>
                        <PromoIcon name={props.iconName} />
                    </IconContainer>
                )}
                {props.withSpinner && <PromoSpinnerCircle isWhite size="16px" />}
            </LinkButton>
        );
    } else if (props.type === 'pseudo') {
        return (
            <PseudoButton variant={variant} {...props}>
                {props.caption}
                {props.iconName && (
                    <IconContainer>
                        <PromoIcon name={props.iconName} />
                    </IconContainer>
                )}
                {props.withSpinner && <PromoSpinnerCircle isWhite size="16px" />}
            </PseudoButton>
        );
    }
    return (
        <CommonButton ref={ref} variant={variant} {...props}>
            {props.caption}
            {props.iconName && (
                <IconContainer>
                    <PromoIcon name={props.iconName} />
                </IconContainer>
            )}
            {props.withSpinner && <PromoSpinnerCircle isWhite size="16px" />}
        </CommonButton>
    );
});

PromoButton.propTypes = {
    type: PropTypes.oneOf(['link', 'pseudo', 'button']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    isInverted: PropTypes.bool,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    tabIndex: PropTypes.string,
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    withSpinner: PropTypes.bool,
};
